import type { PartitionType } from './schemas'

export const PARTITION_TYPE_KO = {
  0: '기본',
  2: '2분할',
  4: '4분할',
  6: '6분할',
  8: '8분할',
  10: '10분할',
  12: '12분할',
  14: '14분할',
  16: '16분할',
} as const satisfies Record<PartitionType, string>
